import AbstractEntity from "../AbstractEntity";

export default class StandardizedItem extends AbstractEntity {
    _id;
    _name;
    _price;
    _maxQuantity;
    _code;
    _enabled;
    _emissionFactor;
    _workId;
    _family;

    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getPrice() {
        return this._price;
    }

    getMaxQuantity() {
        return this._maxQuantity;
    }

    getCode() {
        return this._code;
    }

    isEnabled() {
        return this._enabled;
    }

    getEmissionFactor() {
        return this._emissionFactor;
    }

    getWorkId() {
        return this._workId;
    }

    getFamily() {
        return this._family;
    }

    getClassName() {
        return "standardized_item";
    }
}
